<script setup lang="ts">
import { resolveWebsitePath } from "@/common/utils/websitePath";

definePage({
  beforeEnter: (to) => resolveWebsitePath(to.path),
});
</script>
